module.exports = __webpack_public_path__ + "img/glasses-01.8c1ee629.svg";